// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"4ab18f17","592":"ebb37857","662":"9d976ee0"}[chunkId] + ".chunk.js";
};